import {useContext} from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import dayjs from 'dayjs';
import AuthContext from '../context/AuthContext';
import {postRefreshToken} from '../api/auth';

const baseURL = process.env.API_BASE_URL;

/**
 * Custom hook for creating an Axios instance with JWT authentication.
 *
 * @function
 * @returns {AxiosInstance} Axios instance with JWT authentication.
 */
const useAxios = () => {
  const {authTokens, setAuthTokens} = useContext(AuthContext);

  // custom axios instance with JWT
  const axiosInstance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authTokens?.access_token}`,
    },
  });

  // interceptors for all HTTP calls. checks jwt expiration date,
  // if it is expired, refresh the tokens and send the request
  axiosInstance.interceptors.request.use(async req => {
    console.log(authTokens);

    const user = jwtDecode(authTokens.access_token);
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

    if (!isExpired) return req; // if jwt is not expired, send the request without refreshing tokens

    const response = await postRefreshToken(authTokens.refresh_token); // refresh the tokens

    const newTokens = {
      access_token: response.data.access_token,
      refresh_token: authTokens.refresh_token,
      token_type: response.data.token_type,
    };
    localStorage.setItem('authTokens', JSON.stringify(newTokens));
    setAuthTokens(newTokens); // update the auth state

    req.headers.Authorization = `Bearer ${response.data.access_token}`; //update the req headers with new jwt
    
    return req;
  });

  return axiosInstance;
};

export default useAxios;
